<template>
  <!-- 레이아웃이 있으면 레이아웃 사용, 없으면 기본 v-app -->
  <component :is="resolvedLayout" :class="{ 'has-impersonate-banner': isImpersonating && !hasLayout }">
    <!-- 대리 로그인 배너 (레이아웃 없는 페이지에서만) -->
    <!-- 레이아웃 없는 페이지 -->
    <v-main v-if="!hasLayout" class="app-main" :class="{ 'has-impersonate-banner': isImpersonating }">
      <router-view></router-view>
    </v-main>
    
    <!-- 레이아웃 있는 페이지 -->
    <router-view v-else></router-view>
    
    <!-- 전역 스낵바 -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      location="bottom"
      class="global-snackbar"
    >
      <div class="snackbar-content">{{ snackbar.text }}</div>
      <template v-slot:actions>
        <v-btn
          variant="text"
          @click="hideSnackbar"
          icon="mdi-close"
          size="small"
        />
      </template>
    </v-snackbar>
    
    <!-- 복귀 확인 다이얼로그 -->
    <v-dialog v-model="exitDialog" max-width="380px">
      <v-card class="exit-dialog">
        <v-card-title class="exit-header">
          <span class="exit-header-title">
            <v-icon class="mr-2" color="warning">mdi-arrow-left-circle</v-icon>
            권한 복귀
          </span>
          <button type="button" class="exit-close" aria-label="닫기" @click="exitDialog = false">
            <v-icon size="18">mdi-close</v-icon>
          </button>
        </v-card-title>
        <v-card-text class="exit-body">
          <p><strong>{{ originalUser?.name }}</strong> 계정으로 돌아가시겠습니까?</p>
        </v-card-text>
        <v-card-actions class="exit-actions">
          <v-spacer />
          <v-btn variant="text" class="btn-cancel" @click="exitDialog = false">취소</v-btn>
          <v-btn variant="flat" class="btn-confirm" @click="confirmExit">복귀하기</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </component>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import AdminLayout from './components/layout/AdminLayout.vue';
import StaffLayout from './components/layout/StaffLayout.vue';
import MemberLayout from './components/layout/MemberLayout.vue';

const store = useStore();
const route = useRoute();

// 역할 기반 동적 레이아웃 선택
// 매니저 이상(60+)은 관리자와 같은 AdminLayout. 직원(40~59)만 StaffLayout.
const resolvedLayout = computed(() => {
  if (route.meta.layout) return route.meta.layout;

  const isLoggedIn = store.getters.isLoggedIn;
  const roleLevel = Number(store.getters.actualRoleLevel || store.getters.roleLevel || 0);
  const isImpersonating = store.getters.isImpersonating;

  if (route.meta.roleBasedLayout && isLoggedIn) {
    if (roleLevel >= 60) return AdminLayout;
    if (roleLevel >= 40) return StaffLayout;
  }

  if (route.meta.memberLayout && isLoggedIn) {
    if (isImpersonating) {
      if (roleLevel >= 60) return AdminLayout;
      if (roleLevel >= 40) return StaffLayout;
    }
    return MemberLayout;
  }

  // 4) 기본 v-app
  return 'v-app';
});

// 레이아웃 존재 여부
const hasLayout = computed(() => resolvedLayout.value !== 'v-app');

// 스낵바 상태 가져오기
const snackbar = computed(() => store.getters.snackbar);

// 대리 로그인 관련
const isImpersonating = computed(() => store.getters.isImpersonating);
const originalUser = computed(() => store.getters.originalUser);
const currentUser = computed(() => store.getters.currentUser);
const exitDialog = ref(false);

// 스낵바 숨기기 함수
const hideSnackbar = () => {
  store.commit('hideSnackbar');
};

// 대리 로그인 종료 (확인 다이얼로그 열기)
const exitImpersonation = () => {
  exitDialog.value = true;
};

// 복귀 확인
const confirmExit = async () => {
  await store.dispatch('exitImpersonation');
  window.location.reload();
};
</script>
